import React from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/splash logo.svg";

const AccountDeletion = () => {
    const navigate = useNavigate();

    const handleLinkClick = () => {
        navigate('/');
        window.scrollTo(0, 0);
    };
    return (
        <div className="container mx-auto py-8">
            <Helmet>
                <title>Swop | Account Deletion</title>
            </Helmet>
            <Link to={'/'} onClick={handleLinkClick} className='flex flex-row w-[100px] items-center cursor-pointer justify-between'>
                <img
              src={logo}
              alt=""
              className="w-[52.12px] h-[50px] sm:w-[40px] sm:h-[40px]"
            />
            <h1 className="uppercase text-spay-logo-text font-bold text-3xl sm:text-2xl">
              swop
            </h1>
            </Link>
            <h1 className="text-3xl mt-[40px] font-bold mb-4">Account Deletion</h1>
            <p className="mb-4">
                We understand that you may want to delete your Swop account. Before proceeding, please take note of the following:
            </p>
            <ul className="list-disc pl-6 mb-4">
                <li>Deleting your Swop account will permanently remove all associated data, including transaction history, payment details, and personal settings.</li>
                <li>This action is irreversible. Once your account is deleted, all data cannot be recovered.</li>
                <li>Deletion of your Swop account will also deactivate any active services or subscriptions linked to it.</li>
                <li>If you have any pending transactions or outstanding payments, please settle them before proceeding with the deletion.</li>
            </ul>
            <p className="mb-4">
            If you have any concerns about your data or would like to manage it, please contact our support team for assistance.
            </p>
        </div>
    );
}

export default AccountDeletion;
